'use es6';

import { memoize } from 'underscore';
import { FILENAME_MAX_LENGTH_CHILD_THEME, FILENAME_MAX_LENGTH_CHILD_THEME_FILES, FILENAME_MAX_LENGTH_CUSTOM_WIDGET, FILENAME_MAX_LENGTH_DEFAULT } from 'DesignData/constants/Files';
import { INVALID_CHARS_REGEX, INVALID_CHARS_DOT_ALLOWED_REGEX } from 'DesignData/constants/FilenameValidation';
import * as FolderAssetTypes from 'DesignData/enums/FolderAssetTypes';
import AssetsWithFilenameExtensions from 'DesignData/constants/FolderAssetTypesWithExtensions';
import FolderAssetTypeExtensions from 'DesignData/enums/FolderAssetTypeExtensions';
export const getFileTypeExtensionRegex = memoize(fileType => {
  const fileTypeExtension = FolderAssetTypeExtensions[fileType];
  return fileTypeExtension && new RegExp(`\.${fileTypeExtension}$`, 'i');
});
/**
 * Because our linter doesn't allow JS idiomatic `x == null`
 *
 * @param {Any} obj
 * @return {Boolean}
 */

export function isNullOrUndefined(obj) {
  return obj === null || obj === undefined;
}
/**
 * Validates an email address.
 * http://stackoverflow.com/questions/46155/validate-email-address-in-javascript
 */

export function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}
/**
 * Validates serverless functions paths as used in serverless.json config files.
 */

export function validateServerlessPath(path) {
  // must be truthy strings
  if (!path || typeof path !== 'string') return false; // no whitespace

  if (/\s/.test(path)) return false; // no consecutive forward slashes

  if (/\/\//.test(path)) return false; // allow alpha-numerics, hyphens, underscores, and forward slashes

  return /[^A-Za-z0-9-_\/]+/.test(path) === false;
}
/**
 * Validates file/folder name length.
 * @param {String} filename
 * @param {FolderAssetType} fileType
 */

export function validateFilenameLength(filename, fileType) {
  const maxLength = fileType === FolderAssetTypes.CUSTOM_WIDGET ? FILENAME_MAX_LENGTH_CUSTOM_WIDGET : FILENAME_MAX_LENGTH_DEFAULT;
  return filename.length <= maxLength;
}
/**
 * Validates child theme and child theme files' name lengths.
 * @param {String} filename
 * @param {FolderAssetType} fileType
 */

export function validateChildThemeFilesLength(fileName, fileType) {
  const maxLength = fileType === FolderAssetTypes.THEME ? FILENAME_MAX_LENGTH_CHILD_THEME : FILENAME_MAX_LENGTH_CHILD_THEME_FILES;
  return fileName.length <= maxLength;
}
/**
 * Validates file extensions.
 * @param {String} filename
 * @param {FolderAssetType} fileType
 */

export function validateFilenameExtension(filename, fileType) {
  const fileTypeExtensionRegex = getFileTypeExtensionRegex(fileType);
  return fileTypeExtensionRegex ? fileTypeExtensionRegex.test(filename) : true;
}
/**
 * Validates a file/folder name.
 * @param {String} _filename
 * @param {FolderAssetType} fileType
 */

export function validateFilenameCharacters(_filename, fileType) {
  let filename = _filename;

  if (AssetsWithFilenameExtensions.includes(fileType)) {
    const lastDot = filename.lastIndexOf('.') || filename.length;
    filename = filename.slice(0, lastDot);
    const FILENAME_STARTS_WITH_DOT = /^\./i;
    return !(filename.match(INVALID_CHARS_DOT_ALLOWED_REGEX) || filename.match(FILENAME_STARTS_WITH_DOT));
  }

  return !filename.match(INVALID_CHARS_REGEX);
}